import { ReactNode } from 'react'

export type UtilityWindowWrapperProps = {
  isOpen: boolean
  title: string
  onClose: () => void
  children?: ReactNode
  className?: string
}
